import ContactAdmin from './pages';

export default ContactAdmin;
